module.exports = __webpack_public_path__ + "static/media/googlePlay_v2.bc0ef79b.svg";